<template>
  <div class="base-background-flare">
    <div class="flare-red-container flare-container" ref="flare-red-container">
      <img class="flare flare-red" ref="flare-red" src="@/assets/img/flare-red.svg" alt="flare-red">
    </div>
    <div class="flare-blue-container flare-container" ref="flare-blue-container">
      <img class="flare flare-blue" ref="flare-blue" src="@/assets/img/flare-blue.svg" alt="flare-blue">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { TweenMax, Power1, Sine } from 'gsap'
export default {
  computed: mapState('ui', [
    'backgroundFlareState'
  ]),
  watch: {
    backgroundFlareState (state) {
      this.updateBackgroundFlareState(state)
    }
  },
  mounted () {
    this.initAnimation()
    this.updateBackgroundFlareState(this.backgroundFlareState)
  },
  methods: {
    initAnimation () {
      const dx = this.$el.clientWidth * 0.5
      const dy = this.$el.clientHeight * 0.5
      TweenMax.staggerTo(this.random(0.4, 0.8), { repeat: -1, ease: Power1.easeOut }, 0.3)
      TweenMax.set([this.$refs['flare-red'], this.$refs['flare-blue']], { xPercent: -50, yPercent: -50 })
      this.cycleFlare(this.$refs['flare-red'], 'x', -dx, dx)
      this.cycleFlare(this.$refs['flare-red'], 'y', -dy, dy)
      this.cycleFlare(this.$refs['flare-blue'], 'x', -dx, dx)
      this.cycleFlare(this.$refs['flare-blue'], 'y', -dy, dy)
    },
    cycleFlare (target, prop, min, max) {
      TweenMax.to(target, this.random(3, 6), { [prop]: this.random(min, max), ease: Sine.easeInOut, onComplete: this.cycleFlare, onCompleteParams: [target, prop, min, max] })
    },
    random (min, max) {
      if (max == null) {
        max = min
        min = 0
      }
      return Math.random() * (max - min) + min
    },
    updateBackgroundFlareState (state) {
      TweenMax.to(this.$refs['flare-red-container'], 1, { autoAlpha: state.red ? 1 : 0 })
      TweenMax.to(this.$refs['flare-blue-container'], 1, { autoAlpha: state.blue ? 1 : 0 })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-background-flare {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
}

.flare-container {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}

.flare {
  position: absolute;
  top: 50%;
  left: 50%;
  mix-blend-mode: screen;
  width: 150%;
  height: 150%;
  will-change: transform;
  opacity: 0.6;
}
</style>
